import { Component } from '@angular/core';
import {Router} from '@angular/router';
import 'jquery-slimscroll';


import { AdminGuard } from './../../../_guards/admin.guard';
import { ClientGuard } from './../../../_guards/client.guard';
import { StaffGuard } from './../../../_guards/staff.guard';
import { ManagerGuard } from './../../../_guards/manager.guard';

import { User } from '../../../_models/index';



declare var jQuery:any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html'
})

export class NavigationComponent {

  currentUserID: any;
  currentPhoto: any;
  currentAccessLevel: any;
  currentBrandID: any;
  currentUser!: User;
  users: User[] = [];



  constructor( public router: Router) {
    // this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string);
    // this.currentBrandID = this.currentUser.brand_id;
    // this.currentAccessLevel = this.currentUser.access_level;
    // this.currentPhoto = this.currentUser.access_level;
    // this.currentUserID = this.currentUser.user_id;

  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    jQuery('#side-menu').metisMenu();

    if (jQuery('body').hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%'
      });
    }
  }

  activeRoute(routename: string): boolean {
    console.log('RouterName: ' + routename)
    return this.router.url.indexOf(routename) > -1;

  }






}
